import { useNavigate } from "react-router-dom";
import { ChangeEvent, ChangeEventHandler, useEffect, useState } from "react";
import BannerPicker from "@components/form/BannerPicker";
import ThumbnailPicker from "@components/form/ThumbnailPicker";
import { errorAlert, showLoading, successAlert } from "@hooks/HelperHook";
import useScrollReset from "@hooks/ScrollHook";
import { UpdateUserRequest, UserResponse } from "baaanggg";
import useAlert from "@hooks/AlertHook";
import { useBaaanggg } from "@hooks/BaaangggHook";
import { useAccount } from "@contexts/AccountContext";

function EditProfilePage() {
    useScrollReset()

    const baaanggg = useBaaanggg()
    const { user, refreshAccount } = useAccount();
    const [data, setData] = useState<UpdateUserRequest>();

    const alert = useAlert()

    const [bannerImg, setBannerImg] = useState<File>();
    const [thumbImg, setThumbImg] = useState<File>();


    const handleChange = (e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const { name, value } = e.target
        if (data) {
            setData(prev => prev ? {
                ...prev,
                [name]: value ? value : null
            } : undefined)
        }
    }

    const handleSubmit = async () => {
        try {
            if (!user) {
                alert.failed("Cannot fetch user")
                return;
            }

            if (!data?.username) {
                alert.failed("Please fill username")
                return;
            }

            alert.loading("Updating your data")
            await baaanggg.me.update(data)

            if (bannerImg || thumbImg) {
                alert.loading("Updating your images")
                await baaanggg.me.image({
                    banner: bannerImg,
                    thumbnail: thumbImg
                })
            }

            alert.success("Your data has been updated successfully")
            refreshAccount()
        } catch (e) {
            if (e instanceof Error) {
                alert.failed(e.message)
            }
        }
    }

    useEffect(() => {
        if (user) setData(user)
    }, [user])

    return <>
        <main className="pt-[5.5rem] lg:pt-24">
            <BannerPicker url={data?.bannerUrl || "/src/img/logo/transparant_logo.png"} onChange={setBannerImg} />

            <section className="relative py-16 dark:bg-dark">
                <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
                    <img src="/src/img/gradient_light.jpg" alt="gradient" className="h-full w-full" />
                </picture>

                <div className="container">
                    <div className="mx-auto max-w-[48.125rem] md:flex">
                        <div className="mb-12 md:w-1/2 md:pr-8">
                            <div className="mb-6">
                                <label htmlFor="profile-username" className="mb-1 block font-display text-sm text-jacarta-700 dark:text-white">
                                    Username<span className="text-red">*</span>
                                </label>
                                <input
                                    name="username"
                                    value={data?.username}
                                    onChange={handleChange}
                                    type="text"
                                    id="profile-username"
                                    className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                    placeholder="Enter username"
                                    required
                                />
                            </div>
                            <div className="mb-6">
                                <label htmlFor="profile-email" className="mb-1 block font-display text-sm text-jacarta-700 dark:text-white">
                                    Email<span className="text-red">*</span>
                                </label>
                                <input
                                    name="email"
                                    value={data?.email}
                                    onChange={handleChange}
                                    type="text"
                                    id="profile-email"
                                    className="w-full rounded-lg border-jacarta-100 py-3 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                    placeholder="Enter email"
                                    required
                                />
                            </div>
                            <div className="mb-6">
                                <label htmlFor="profile-twitter" className="mb-1 block font-display text-sm text-jacarta-700 dark:text-white">
                                    Links
                                </label>
                                <div className="relative">
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fab"
                                        data-icon="twitter"
                                        className="pointer-events-none absolute top-1/2 left-4 h-4 w-4 -translate-y-1/2 fill-jacarta-300 dark:fill-gray-400"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 512 512"
                                    >
                                        <path
                                            d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
                                        ></path>
                                    </svg>
                                    <input
                                        name="twitterUrl"
                                        value={data?.twitterUrl}
                                        onChange={handleChange}
                                        type="text"
                                        id="profile-twitter"
                                        className="w-full rounded-t-lg border-jacarta-100 py-3 pl-10 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-inset focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                        placeholder="Your Twitter username"
                                    />
                                </div>
                                <div className="relative">
                                    <svg
                                        aria-hidden="true"
                                        focusable="false"
                                        data-prefix="fab"
                                        data-icon="instagram"
                                        className="pointer-events-none absolute top-1/2 left-4 h-4 w-4 -translate-y-1/2 fill-jacarta-300 dark:fill-gray-400"
                                        role="img"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 448 512"
                                    >
                                        <path
                                            d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
                                        ></path>
                                    </svg>
                                    <input
                                        name="instagramUrl"
                                        value={data?.instagramUrl}
                                        onChange={handleChange}
                                        type="text"
                                        id="profile-instagram"
                                        className="-mt-px w-full border-jacarta-100 py-3 pl-10 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-inset focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                        placeholder="Your Instagram username"
                                    />
                                </div>
                                <div className="relative">
                                    <svg aria-hidden="true" focusable="false" data-prefix="fab" data-icon="discord"
                                        className="pointer-events-none absolute top-1/2 left-4 h-4 w-4 -translate-y-1/2 fill-jacarta-300 dark:fill-gray-400" role="img"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                                        <path
                                            d="M524.531,69.836a1.5,1.5,0,0,0-.764-.7A485.065,485.065,0,0,0,404.081,32.03a1.816,1.816,0,0,0-1.923.91,337.461,337.461,0,0,0-14.9,30.6,447.848,447.848,0,0,0-134.426,0,309.541,309.541,0,0,0-15.135-30.6,1.89,1.89,0,0,0-1.924-.91A483.689,483.689,0,0,0,116.085,69.137a1.712,1.712,0,0,0-.788.676C39.068,183.651,18.186,294.69,28.43,404.354a2.016,2.016,0,0,0,.765,1.375A487.666,487.666,0,0,0,176.02,479.918a1.9,1.9,0,0,0,2.063-.676A348.2,348.2,0,0,0,208.12,430.4a1.86,1.86,0,0,0-1.019-2.588,321.173,321.173,0,0,1-45.868-21.853,1.885,1.885,0,0,1-.185-3.126c3.082-2.309,6.166-4.711,9.109-7.137a1.819,1.819,0,0,1,1.9-.256c96.229,43.917,200.41,43.917,295.5,0a1.812,1.812,0,0,1,1.924.233c2.944,2.426,6.027,4.851,9.132,7.16a1.884,1.884,0,0,1-.162,3.126,301.407,301.407,0,0,1-45.89,21.83,1.875,1.875,0,0,0-1,2.611,391.055,391.055,0,0,0,30.014,48.815,1.864,1.864,0,0,0,2.063.7A486.048,486.048,0,0,0,610.7,405.729a1.882,1.882,0,0,0,.765-1.352C623.729,277.594,590.933,167.465,524.531,69.836ZM222.491,337.58c-28.972,0-52.844-26.587-52.844-59.239S193.056,219.1,222.491,219.1c29.665,0,53.306,26.82,52.843,59.239C275.334,310.993,251.924,337.58,222.491,337.58Zm195.38,0c-28.971,0-52.843-26.587-52.843-59.239S388.437,219.1,417.871,219.1c29.667,0,53.307,26.82,52.844,59.239C470.715,310.993,447.538,337.58,417.871,337.58Z">
                                        </path>
                                    </svg>
                                    <input
                                        name="discordUrl"
                                        value={data?.discordUrl}
                                        onChange={handleChange}
                                        type="text"
                                        id="profile-website"
                                        className="-mt-px w-full border-jacarta-100 py-3 pl-10 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-inset focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                        placeholder="Your Discord id"
                                    />
                                </div>
                                <div className="relative">
                                    <svg className="bi bi-file-earmark-check-fill pointer-events-none absolute top-1/2 left-4 h-4 w-4 -translate-y-1/2 fill-jacarta-300 dark:fill-gray-400" role="img"
                                        xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
                                        <path d="M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zm1.354 4.354-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708.708z" />
                                    </svg>
                                    <input
                                        name="whitepaperUrl"
                                        value={data?.whitepaperUrl}
                                        onChange={handleChange}
                                        type="text"
                                        id="profile-website"
                                        className="-mt-px w-full rounded-b-lg border-jacarta-100 py-3 pl-10 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-inset focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                        placeholder="Your white paper Link"
                                    />
                                </div>
                            </div>
                            <div className="mb-6">
                                <label className="mb-1 block font-display text-sm text-jacarta-700 dark:text-white">Wallet Address</label>
                                <button
                                    className="js-copy-clipboard flex w-full select-none items-center rounded-lg border border-jacarta-100 bg-white py-3 px-4 hover:ring-2 hover:ring-jacarta-500/10 focus:ring-jacarta-500 dark:border-gray-400 dark:bg-gray-900 dark:text-white dark:placeholder:text-gray-400"
                                    data-tippy-content="Copy"
                                >
                                    <span className="overflow-hidden text-ellipsis">
                                        {user?.walletAddress || "Address"}
                                    </span>
                                </button>
                            </div>

                            <button
                                onClick={handleSubmit}
                                className="rounded-full bg-jacarta-500 py-3 px-8 text-center font-semibold text-white transition-all hover:bg-jacarta-600"
                            >
                                Update Profile
                            </button>
                        </div>

                        <div className="flex space-x-5 md:w-1/2 md:pl-8">
                            <form className="shrink-0">
                                <ThumbnailPicker onChange={setThumbImg} url={data?.thumbUrl || "/src/img/logo/transparant_logo.png"} />
                            </form>
                            <div className="mt-4">
                                <span className="mb-3 block font-display text-sm text-jacarta-700 dark:text-white">Profile Image</span>
                                <p className="text-sm leading-normal dark:text-gray-400">
                                    We recommend an image with Max size 5mb.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    </>
}

export default EditProfilePage;